(<template>
  <div class="list">
    <div v-if="userList.length > 0" id="user-list">
      <h1 v-translate>Tourinfo users</h1>
      <el-table :data="userList" border>
        <el-table-column type="expand">
          <template slot-scope="user">
            <div class="user-list-flex-container">
              <div class="user-list-thumbnail">
                <img class="user-list-image" :src="avatarUrl(user.row.email)"/>
              </div>
              <div class="user-list-content">
                <p v-if="user.row.email">
                  <strong><translate>Email</translate>:</strong>&nbsp;{{ user.row.email }}
                </p>
                <p v-if="user.row.phoneNumber">
                  <strong><translate>Phone number</translate>:</strong>&nbsp;{{ user.row.phoneNumber }}
                </p>
                <p>
                  <strong><translate>Status</translate>:</strong>&nbsp;
                  <span :style="activeFontColor(user.row.status)">{{ user.row.status }}</span>
                </p>
              </div>
              <div class="user-list-buttons">
                <el-button v-if="user.row.status === 'active' && user.row.username !== $session.get('username')"
                           class="ti-user-list-button"
                           type="danger"
                           @click="deactivate(user.row.id)">
                  <span v-translate>Deactivate</span>
                </el-button>
                <el-button v-if="user.row.status === 'inactive' && user.row.username !== $session.get('username')"
                           class="ti-user-list-button"
                           type="success"
                           @click="activate(user.row.id)">
                  <span v-translate>Activate</span>
                </el-button>
                <el-button v-if="user.row.username !== $session.get('username')"
                           class="ti-user-list-button"
                           type="warning"
                           @click="resetPassword(user.row.id)">
                  <span v-translate>Reset password</span>
                </el-button>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="username" align="center">
          <template slot-scope="user">
            {{ user.row.username }}
          </template>
        </el-table-column>
        <el-table-column :label="fullName" align="center">
          <template slot-scope="user">
            {{ user.row.firstName }} {{ user.row.lastName }}
          </template>
        </el-table-column>
        <el-table-column :label="role" align="center">
          <template slot-scope="user">
            {{ user.row.role }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <h1 v-else v-translate>There are no Tourinfo users...</h1>
  </div>
</template>)

(<script>
import axios from 'axios'
import md5 from 'md5'

export default {
  name: 'ti-user-list',
  data () {
    return {
      username: this.$gettext('Username'),
      fullName: this.$gettext('Full name'),
      role: this.$gettext('Role'),
      userList: []
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.$session.exists()) {
        if (vm.$session.get('role') === 'admin') {
          next()
        } else {
          this.$message({
            type: 'warning',
            message: this.$gettext('Please sign out and sign in as an admin user!')
          })
          next('/')
        }
      } else {
        next('/signin')
      }
    })
  },
  created () {
    this.getUserList()
  },
  methods: {
    avatarUrl (email) {
      return `https://www.gravatar.com/avatar/${md5(email.trim().toLowerCase())}`
    },
    activeFontColor (status) {
      if (status === 'active') {
        return {
          color: 'green'
        }
      } else {
        return {
          color: 'red'
        }
      }
    },
    getUserList () {
      axios({
        method: 'get',
        url: `${process.env.SERVER_URL}/users`,
        withCredentials: true
      })
      .then(response => {
        var tiUsers = []
        response.data.map(user => {
          if (user.role === 'TI User') {
            tiUsers.push(user)
          }
        })
        this.userList = tiUsers
      })
      .catch(error => {
        var msg
        if (error.response) {
          msg = error.response.data || error.response.statusText
        } else {
          msg = error.message
        }
        this.$message({
          type: 'error',
          message: msg
        })
      })
    },
    deactivate (id) {
      this.$confirm(this.$gettext('Are you sure to deactivate the user?'), 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(() => {
        axios({
          method: 'post',
          url: `${process.env.SERVER_URL}/users/${id}/deactivate`,
          withCredentials: true
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: this.$gettext('User has deactivated')
          })
          this.getUserList()
        })
        .catch(error => {
          var msg
          if (error.response) {
            msg = error.response.data || error.response.statusText
          } else {
            msg = error.message
          }
          this.$message({
            type: 'error',
            message: msg
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$gettext('Deactivate has canceled')
        })
      })
    },
    activate (id) {
      this.$confirm(this.$gettext('Are you sure to activate the user?'), 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(() => {
        axios({
          method: 'post',
          url: `${process.env.SERVER_URL}/users/${id}/activate`,
          withCredentials: true
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: this.$gettext('User has been activated')
          })
          this.getUserList()
        })
        .catch(error => {
          var msg
          if (error.response) {
            msg = error.response.data || error.response.statusText
          } else {
            msg = error.message
          }
          this.$message({
            type: 'error',
            message: msg
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$gettext('Activation was canceled')
        })
      })
    },
    resetPassword (id) {
      this.$confirm(this.$gettext('Are you sure to reset the user\'s password?'), 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(() => {
        axios({
          method: 'post',
          url: `${process.env.SERVER_URL}/users/${id}/reset`,
          withCredentials: true
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: this.$gettext('Password has reseted')
          })
        })
        .catch(error => {
          var msg
          if (error.response) {
            msg = error.response.data || error.response.statusText
          } else {
            msg = error.message
          }
          this.$message({
            type: 'error',
            message: msg
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$gettext('Password reset has canceled')
        })
      })
    }
  }
}
</script>)

(<style>
.user-list-flex-container {
  width: 100%;
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.user-list-thumbnail {
  width: 20%;
  text-align: center;
}
.user-list-content {
  width: 40%;
  text-align: left;
}
.user-list-buttons {
  width: 40%;
  height: 100%;
}
.user-list-image {
  height: 80%;
  padding: 5%;
  border-radius: 50%;
}
.ti-user-list-button {
  margin: 0.5em;
}
</style>)



// WEBPACK FOOTER //
// src/components/TI-User-List.vue